import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import moment from "moment";
import { queryGetAgents } from "Apollo";
import Card from "./Card";

export default graphql(queryGetAgents)(
  class List extends Component {
    render() {
      const { getAgents, refetch } = this.props.data;
      const renders = [];
      if (getAgents) {
        for (const agent of getAgents) {
          const labels = [];
          for (const label of agent.labels) {
            labels.push({
              label: label.labelTemplate.displayName,
              value: label.labelTemplate,
              color: "#" + label.labelTemplate.color
            });
          }
          // sort by order and date
          labels.sort((a, b) => {
            if (a.value.order !== b.value.order) {
              return a.value.order > b.value.order;
            } else {
              return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
            }
          });

          renders.push(
            <Card
              key={agent.id}
              id={agent.id}
              username={agent.username}
              displayName={agent.displayName}
              displayPicture={agent.displayPicture}
              labels={labels}
              refetch={refetch}
            />
          );
        }
      }
      return <Wrapper>{renders}</Wrapper>;
    }
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/team-panel/ListWithQuery.js